import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDoubleSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.753 17a1 1 0 0 1-.78-.369l-3.25-3.984a.994.994 0 0 1 0-1.255l3.25-3.985a1 1 0 0 1 1.08-.369 1 1 0 0 1 .724.88 1 1 0 0 1-.254.744l-2.74 3.357 2.74 3.357A.994.994 0 0 1 8.753 17M14.806 17a1 1 0 0 1-.897-.57.99.99 0 0 1 .127-1.054l2.74-3.357-2.74-3.357a.996.996 0 0 1 .113-1.439 1 1 0 0 1 1.437.184l3.25 3.985a.994.994 0 0 1 0 1.255l-3.25 3.984a1 1 0 0 1-.78.369"
    />
  </svg>
);
export default SvgChevronDoubleSmall;
